import {IconTypes} from "@/shared/models/icon-types";

export class SearchResult {
    constructor(
        public id: string,
        public url: string,
        public title: string,
        public subtitle: string,
        public bodyText: string[],
        public image: SearchResultImage,
        public types: string[],
        public tags: string[] = [],
        public icon: IconTypes = IconTypes.Default,
        public categories: string[] = [],
        public metadata: string[] = [],
    ) {
    }
}

export class SearchResultImage {
    constructor(
        public url: string,
        public alt: string,
    ) {
    }
}